// extracted by mini-css-extract-plugin
module.exports = {"col-card":"PricingSection_col-card__u9vMf"};